import { render, staticRenderFns } from "./partnerCurrentWithholdComponent.vue?vue&type=template&id=1d941812&scoped=true&"
import script from "./partnerCurrentWithholdComponent.vue?vue&type=script&lang=js&"
export * from "./partnerCurrentWithholdComponent.vue?vue&type=script&lang=js&"
import style0 from "./partnerCurrentWithholdComponent.vue?vue&type=style&index=0&id=1d941812&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d941812",
  null
  
)

export default component.exports